import LogoIcon from 'atoms/Icons/LogoText';
import cn from 'classnames';
import React from 'react';

import s from './LogoText.module.scss';

type ILogoText = {
  className?: string;
  fill?: string;
};

const LogoText = ({ className, fill }: ILogoText) => (
  <div className={cn(s.LogoText, className)}>
    <LogoIcon fill={fill} />
  </div>
);

export default LogoText;
